const getSlotsForBusiness = require("./getSlotsForBusiness");
const { fetchDoc } = require("../firebase");

module.exports = async (firebase, businessUid, date, pax, duration) => {
  const business = await fetchDoc(firebase, `businesses/${businessUid}`);
  if (!business) return [];
  const slots = await getSlotsForBusiness(business, date, pax, duration);
  if (slots) return slots;
  return [];
};
